// extracted by mini-css-extract-plugin
export default {"licenses":"styles_licenses__Xc9sx"};